import { ACCOUNTING_APP_STORES } from "@intrasync/accounting";
import AccountingDashboardStore from "./Dashboard/AccountingDashboard.Store";
import BillsStore from "./Purchases/Bills/Bills.Store";
// import CustomersStore from "./Sales/Customers/Customers.Store";
import InvoicesStore from "./Sales/Invoices/Invoices.Store";
import PaymentsStore from "./Payments/Payments.Store";
// import SuppliersStore from "./Purchases/Suppliers/Suppliers.Store";
import { POConversionViewStore } from "./po-conversion/stores/POConversionViewStore";
import { InvoiceConversionViewStore } from "./invoice-conversion/stores/InvoiceConversionViewStore";

const accountingStoreList = [
  ...ACCOUNTING_APP_STORES,
  { name: "accountingDashboardStore", store: AccountingDashboardStore },
  { name: "billsViewStore", store: BillsStore },
  // { name: "customersViewStore", store: CustomersStore },
  { name: "invoicesViewStore", store: InvoicesStore },
  { name: "paymentsViewStore", store: PaymentsStore },
  //   { name: "suppliersViewStore", store: SuppliersStore },
  { name: "poConversionViewStore", store: POConversionViewStore },
  { name: "invoiceConversionViewStore", store: InvoiceConversionViewStore },
];

export default accountingStoreList;
